/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';

export default (function(config){
    config.selector = (typeof  config.selector !== 'undefined') ?   config.selector : 'e-learning-percentage-complete';
    config.route = (typeof  config.route !== 'undefined') ?   config.route : '/widget/elearning/%type%/%id%/percentage-complete';

    let elements = document.getElementsByClassName(config.selector);

    /**
     * Check if the ID and the type is valid
     *
     * @param type
     * @param id
     * @returns {boolean}
     */
    function isValid(type, id) {
        if (type !== 'module' && type !== 'course') {
            console.log('Type must be course or module');
            console.log('Type: ' + type);
            return false;
        }

        if (id === 'undefined') {
            console.log('ID is required');
            console.log('ID: ' + id);
            return false;
        }
    }

    /**
     * Create the route string
     *
     * @param type
     * @param id
     *
     * @returns {string}
     */
    function createRoute (type, id) {
        return Utils.generateRouteFromPattern({
                pattern : {
                    '%type%' : type,
                    '%id%': id
                },
                route : config.route,
                env : config.env,
                locale: config.locale
            });
    }

    function updateValue(element, value, hasPassed)
    {
        let status = '';
        let msg = '';
        if(hasPassed === false) {
            status = 'failed';
            // There is a missing translation here.
            // Fix and reinstate when the failure status is corrected. [JP, Dec 2019]
            // msg = translations.failed;
        }
        element.getElementsByClassName('percentage-value')[0].innerHTML = "<div class=\"background p" + value + " " + status + "\" title=\"" + msg + "\"><span>"+ value +"%</span></div>";
    }

    /**
     * @param route
     * @param element
     */
    function run(route, element, id) {

        /**
         * Ran on AJAX success
         *
         * @param response
         */
        let success = function(response){
            let percentage = (typeof  response.percentage_complete !== 'undefined') ?   response.percentage_complete : 0;
            let hasPassed = (typeof  response.has_passed !== 'undefined') ?   response.has_passed : null;
            updateValue(element, percentage, hasPassed);

            if (percentage > 0) {
                updateStartResumeBtn(id, translations.resume);
            }
        };


        /**
         * Ran on AJAX error
         *
         * @param response
         */
        let error = function(response){

        };

        Ajax.getRequest(route, success, error);
    }

    for (let item of elements) {
        let type = item.getAttribute('data-type');
        let id = item.getAttribute('data-id');

        if(false === isValid(type, id)) {
            console.log('Cannot make the request');
            return false;
        }

        let route = createRoute(type, id);

        run(route, item, id);
    }

    function updateStartResumeBtn(id, text) {
        let elements = document.getElementsByClassName('start-resume-btn');
        for (let item of elements) {
            let element_id = item.getAttribute('data-id');
            if (element_id === id) {
                item.innerHTML = text;
            }
        }
    }



});


